export default __webpack_public_path__ + "static/Lexend-Black-53f7e688de69f16dcd461320afb80bd3.woff2";